import { API_BASE } from '../config/env';
import { httpConstants } from '../constants';
import { httpService } from './httpService';

export interface FetchAISolutionByIDParams {
  solutionId: string;
  diagramId: string;
  organizationId: string;
}

/**
 * Fetch detailed AI solution data (including agent information) for a given solution ID.
 */
export const fetchAISolutionByID = async <T = unknown>(
  params: FetchAISolutionByIDParams
): Promise<T | null> => {
  const { solutionId, diagramId, organizationId } = params;

  try {
    const baseUrl = `${API_BASE}/api/v1/e2e_taxonomy/opportunities/with-agent`;
    const url = `${baseUrl}/${solutionId}/?diagram_id=${diagramId}&organization_id=${organizationId}`;

    const response = await httpService<T>(httpConstants.METHOD_TYPE.GET, url, undefined);
    return (response as T) ?? null;
  } catch (error) {
    console.error('Error fetching AI solution by ID:', error);
    return null;
  }
};

export const fetchAISolutionWithAgentEnablement = async <T = unknown>(
  params: FetchAISolutionByIDParams
): Promise<T | null> => {
  const { solutionId, diagramId, organizationId } = params;

  try {
    const baseUrl = `${API_BASE}/api/v1/e2e_taxonomy/opportunities/with-agent-enablement`;
    const url = `${baseUrl}/${solutionId}/?diagram_id=${diagramId}&organization_id=${organizationId}`;

    const response = await httpService<T>(httpConstants.METHOD_TYPE.GET, url, undefined);
    return (response as T) ?? null;
  } catch (error) {
    console.error('Error fetching AI solution by ID:', error);
    return null;
  }
};
